<template>
  <div id="crossSell" class="cross-sell">
    <div class="cross-sell__header header">
      <div class="header__text" v-html="$t('cross_sell.description')"></div>
      <button class="add btn btn-primary" @click="addSuggestion">{{$t('cross_sell.add')}}</button>
    </div>
    <div class="cross-sell__suggestions" v-if="ready">
      <CrossSellSuggestion v-for="(suggestion, index) of crossSells" :key="suggestion.tempId" :suggestion="suggestion"
         :ignoredItem="crossSellItemIdsToIgnore" :initialNameCache="nameCache" :validate="validate" :index="index"
         @remove="removeSuggestion(suggestion.tempId)"
         @setSuggestionItem="setSuggestionItem(...arguments, suggestion.tempId)"
         @setSuggestionText="setSuggestionText(...arguments, suggestion.tempId)"
      />
      <div class="suggestion--hidden" v-if="crossSells.length > 0"></div>
      <div class="suggestions__empty" v-if="crossSells.length === 0">
        {{ $t('cross_sell.empty') }}
      </div>
    </div>
  </div>
</template>

<script>
import CrossSellSuggestion from "@/components/qsr/CrossSellSuggestion.vue";
import {Core} from "@/core/Core";

export default {
  name: "CrossSell",

  components: { CrossSellSuggestion },

  props: {
    item: Object,
    validate: Object
  },

  data() {
    return {
      ready: false,
      nameCache: new Map()
    }
  },

  async mounted() {
    this.validate.validateAllOnce();
    let missingIds = this.crossSellItemIds
        .filter(e => !this.nameCache.has(e));

    if (missingIds.length) {
      let response = await Core.request('GET', `/api/entity/orderable/select`, {inventory: this.inventoryId, id: missingIds});
      for (let row of response) {
        this.nameCache.set(row.id, row.name);
      }
    }
    this.ready = true;
  },

  computed: {
    crossSellItemIds() {
      let itemsId = [];
      for (let crossSell of this.crossSells) {
        if (crossSell.item) {
          itemsId.push(crossSell.item);
        }
      }
      return itemsId;
    },
    crossSellItemIdsToIgnore() {
      return [...this.crossSellItemIds, this.itemId];
    },
    company() {
      return this.$store.state.contextCompany;
    },
    inventoryId() {
      return this.company ? this.company.inventory.id : null;
    },
    crossSells() {
      return this.item.crossSells;
    },
    itemId() {
      return this.item.id;
    }
  },

  methods: {
    addSuggestion() {
      this.$emit("addSuggestion");
    },
    removeSuggestion(suggestionTempId) {
      this.$emit("removeSuggestion", suggestionTempId);
    },
    setSuggestionItem(itemId, suggestionTempId) {
      this.$emit("setSuggestionItem", itemId, suggestionTempId);
    },
    setSuggestionText(itemText, suggestionTempId) {
      this.$emit("setSuggestionText", itemText, suggestionTempId);
    }
  }
}
</script>

<style lang="scss" scoped>
 #crossSell {
   .cross-sell__header {
     display: flex;
     .header__text {
       flex-grow: 1;
       padding-right: 55px;
     }
     .add {
       flex-shrink: 0;
       height: 40px
     }
   }
   .cross-sell__suggestions {
     display: flex;
     flex-wrap: wrap;
     margin: 0 -20px;
   }
   .suggestion--hidden {
     display: flex;
     min-width: calc(50%);
     flex-grow: 1;
   }

   .suggestions__empty {
     display: flex;
     justify-content: center;
     flex-grow: 1;
     padding-top: 20px;
     padding-left: 20px;
     font-style: italic;
     color: #808080;
   }
 }

 #app.mobile #crossSell {
   .cross-sell__header {
     flex-direction: column;
     .header__text {
       padding-right: 0;
     }
     .add {
       margin-top: 20px;
     }
   }
   .cross-sell__suggestions {
     margin: 0;
     flex-wrap: wrap;
     .suggestion {
       flex-basis: 100%;
       margin: 20px 0 0 0;
       flex-grow: 1;
     }
     .suggestion--hidden {
       display: none;
     }
   }
 }
</style>